// extracted by mini-css-extract-plugin
export var highlightFade = "_21-4";
export var highlighted = "_21-3";
export var table = "_21-1";
export var tableContainer = "_21-0";
export var totalsRow = "_21-2";